import { render, staticRenderFns } from "./InboxContent.vue?vue&type=template&id=26ff02b5&scoped=true&"
import script from "./InboxContent.vue?vue&type=script&lang=js&"
export * from "./InboxContent.vue?vue&type=script&lang=js&"
import style0 from "./InboxContent.vue?vue&type=style&index=0&id=26ff02b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ff02b5",
  null
  
)

export default component.exports